const dropTypes = Object.freeze({
  Alta: 1,
  Baja: 2,
  Traslado: 3,
});

export default dropTypes;
